export enum LocaleEnum {
  AT = 'de-AT',
  DE = 'de-DE',
  CH = 'de-CH',
  EN = 'en-US',
  IE = 'en-IE'
}
Object.freeze(LocaleEnum);

export enum UrlLocaleEnum {
  AT = 'at',
  DE = 'de',
  CH = 'ch',
  EN = 'en',
  IE = 'ie'
}
Object.freeze(UrlLocaleEnum);

export enum LocaleAliasEnum {
  AT = 'deAT',
  DE = 'deDE',
  CH = 'deCH',
  EN = 'enUS',
  IE = 'enIE'
}
Object.freeze(LocaleAliasEnum);

export type SlugLocale = {
  locale: LocaleEnum;
  slug: string;
};

export enum LanguageEnum {
  DE = 'de',
  EN = 'en'
}

export const localeAliasToLocale = (alias): LocaleEnum => {
  switch (alias) {
    case LocaleAliasEnum.AT:
      return LocaleEnum.AT;
    case LocaleAliasEnum.DE:
      return LocaleEnum.DE;
    case LocaleAliasEnum.CH:
      return LocaleEnum.CH;
    case LocaleAliasEnum.EN:
      return LocaleEnum.EN;
    case LocaleAliasEnum.IE:
      return LocaleEnum.IE;
    default:
      throw new Error(`The locale alias provided does not exist: ${alias}`);
  }
};

export const localeToLocaleAlias = (locale: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DE:
      return LocaleAliasEnum.DE;
    case LocaleEnum.AT:
      return LocaleAliasEnum.AT;
    case LocaleEnum.CH:
      return LocaleAliasEnum.CH;
    case LocaleEnum.EN:
      return LocaleAliasEnum.EN;
    case LocaleEnum.IE:
      return LocaleAliasEnum.IE;
    default:
      throw new Error(`The locale provided does not exist: ${locale}`);
  }
};

export const getSupportedLocalesAndAlias = (
  ignoreLocales: LocaleEnum[] = []
): {
  locales: LocaleEnum[];
  localesAlias: LocaleAliasEnum[];
} => {
  const localeAndAlias = {
    [LocaleEnum.AT]: LocaleAliasEnum.AT,
    [LocaleEnum.DE]: LocaleAliasEnum.DE,
    [LocaleEnum.CH]: LocaleAliasEnum.CH,
    [LocaleEnum.IE]: LocaleAliasEnum.IE,
    [LocaleEnum.EN]: LocaleAliasEnum.EN
  };

  ignoreLocales.forEach(ignoreLocale => {
    delete localeAndAlias[ignoreLocale];
  });

  return {
    locales: Object.keys(localeAndAlias) as LocaleEnum[],
    localesAlias: Object.values(localeAndAlias)
  };
};

// External/Integrated apps might need a language key rather than a locale.
// Example: Salesforce Forms (Lightning Out)
export const localeToLanguage = (locale: LocaleEnum): LanguageEnum => {
  switch (locale) {
    case LocaleEnum.EN:
    case LocaleEnum.IE:
      return LanguageEnum.EN;
    case LocaleEnum.DE:
    case LocaleEnum.CH:
    case LocaleEnum.AT:
    default:
      return LanguageEnum.DE;
  }
};
